// extracted by mini-css-extract-plugin
export default {"input":"EditVariablePayrollFileInput_input__9tNRj"};